<template>
  <v-app-bar class="app-topbar" app clipped-left base-color="var(--white)" elevation="0">
    <v-breadcrumbs :items="breadcrumb" class="v-col-4">
      <v-breadcrumbs-item class="v-col-6 px-0">
        <v-col cols="12" class="px-0">
          <v-text-field :value="dashboard_data.title" hide-details variant="solo" density="compact"
            placeholder="Form name" @input="updateName"></v-text-field>
        </v-col>
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-spacer></v-spacer>
    <v-btn class="btn text-white" variant="flat" color="var(--primary)" @click="saveDashboard">Save</v-btn>
  </v-app-bar>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    dashboard_data: { type: Object, default: () => ({}) },
  },

  computed: {
    breadcrumb() {
      return [
        {
          title: 'Dashboards',
          disabled: false,
          to: '/dashboards',
        },
        {
          title: '', // Display current name or fallback
          disabled: true, // Set to true if this should not be clickable
        },
      ];
    },
  },

  methods: {
    updateName(event) {
      // Emit the updated name so the parent component can handle it
      this.$emit('update:dashboard_data', { ...this.dashboard_data, name: event.target.value });
    },

    saveDashboard() {
      // Ensure that the dashboard_data has a valid ID and name
      if (!this.dashboard_data.id || !this.dashboard_data.title) {
        // this.$toast.error('Dashboard ID or name is missing.'); // Display an error message
        return;
      }

      // Make an API call to update the dashboard data
      axios.put(`/projects/${this.dashboard_data.id}`, this.dashboard_data)
        .then(response => {
          // Handle success
          if (response.data.success) {
            // this.$toast.success('Dashboard updated successfully!'); // Show a success message
          } else {
            // this.$toast.error('Failed to update dashboard.'); // Handle the case when success is false
          }
        })
        .catch(error => {
          // Handle error
          console.error('Error updating dashboard:', error); // Log the error for debugging
          // this.$toast.error('An error occurred while updating the dashboard.'); // Show an error message
        });
    }
  }
};
</script>

<style>
.app-topbar {
  border-bottom: 1px solid var(--neutral-200);
}

.app-topbar-organisation .v-list-item {
  padding: 0px !important;
}

.app-topbar .v-list-item-title {
  font-size: 1.6rem;
}
</style>
